/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
    FormControl,
    InputLabel,
    Input,
    Select,
    MenuItem,
    ListItemText,
    Grid,
    Typography,
} from '@material-ui/core';

class TableFilterDropDown extends Component {
    constructor(props) {
        super(props);
        const { filter, activeFilters } = this.props;

        this.state = { value: activeFilters[filter.fieldName] || '' };
    }

    handleChange = (event) => {
        const { onChange, filter } = this.props;
        this.setState({ value: event.target.value }, () => {
            onChange('dropdown', filter.fieldName, this.state.value);
        });
    };

    render() {
        const { filter } = this.props;

        return (
            <Grid>
                <FormControl style={{ width: '100%' }}>
                    <InputLabel htmlFor={filter.fieldName}>{filter.label}</InputLabel>
                    <Select
                        value={this.state.value}
                        onChange={this.handleChange}
                        input={<Input id={filter.fieldName} name={filter.fieldName} />}
                    >
                        <MenuItem id="yeself-menu-item" value="">
                            <ListItemText primary="None" />
                        </MenuItem>
                        {filter.value.map((name) => (
                            <MenuItem id="yeself-menu-item" key={name} value={name}>
                                <ListItemText primary={name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        );
    }
}

export default TableFilterDropDown;
